// extracted by mini-css-extract-plugin
module.exports = {"content":"Workflow_content__eJPus"};